export default {
  homepage: '/',
  dashboard: '/app/dashboard',
  profile: '/app/profile',
  organisations: '/app/organisations',
  organisationPage: '/app/organisations/:id'
}
